export const VALUES = {
  react: 'React',
  reactionsUnavailable: 'Reactions are currently unavailable',
  copilotDisplayName: 'Copilot',
}
